export const clearAllIntervals = () => {
  const interval_id = window.setInterval(function () {},
  Number.MAX_SAFE_INTEGER);
  for (let i = 1; i < interval_id; ++i) {
    clearInterval(i);
  }
};
